/**
 * Report Studio - Create New Report page.
 * Wizard for creating a new report (blank or from template).
 */

import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { CreateReportPage } from '@/features/analytics/report-studio';
import i18n from '@/lib/i18n';

const searchSchema = z.object({
  templateId: z.string().optional(),
});

export const Route = createFileRoute(
  '/_authenticated/analytics/report-studio/new'
)({
  validateSearch: searchSchema,
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.reportStudioNewReport'),
  }),
  component: NewReportPage,
});

function NewReportPage() {
  const { templateId } = Route.useSearch();
  return (
    <div className="min-h-screen bg-background p-6 lg:p-8">
      <CreateReportPage preselectedTemplateId={templateId} />
    </div>
  );
}
